import { I9DocumentGroupsEnum, I9DocumentUploadProvider } from '@swipejobs/i9-document-validations-react';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React, { useEffect } from 'react';
import I9DocumentUploadV1 from './I9DocumentUploadV1';
import { WorkStatus } from '@models/onboarding-review/section2-document-upload';
import { ISection2DocumentUploadStore } from '@stores/onboarding-review/section2-document-upload-store';
import { observer } from 'mobx-react';
import { OnConfirmType } from '@models/onConfirm-type';

interface Props {
  workStatus: WorkStatus | undefined;
  store: ISection2DocumentUploadStore;
  onConfirm: OnConfirmType;
  onUseOtherDocuments?: () => void;
  isReceiptUpload?: boolean;
}

const I9DocumentUploadV1Wrapper = ({ workStatus, store, onConfirm, isReceiptUpload, onUseOtherDocuments}: Props) => {
  useEffect(() => {
    // @ts-ignore
    if(store.i9StatusDetails && store?.i9StatusDetails?.i9Section2Status === 'RECEIPT_REPLACEMENT') {
      store.getReceiptDocuments();
    } else {
      if(workStatus !== undefined) {
        store.getDocumentDetailsByCitizenshipAsync(workStatus).then();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workStatus, store.i9StatusDetails]);

  const getDocumentResponse = () => {
    // @ts-ignore
       if (store.i9StatusDetails && store?.i9StatusDetails?.i9Section2Status === 'RECEIPT_REPLACEMENT') {
      return Object.values(store.receiptUploadDocument ?? {}) ?? [];
     }
     return Object.values(store.documentDetails ?? {}) ?? [];
  };

  const checkDocumentGroup = (documentGroup: I9DocumentGroupsEnum) => {
      if (store.receiptUploadDocument) {
          const receiptData = Object.values(store.receiptUploadDocument ?? {});
          if (documentGroup === I9DocumentGroupsEnum.I9_LIST_A) {
              const listADocumentPresent = receiptData.find((item) =>
                  item.documentGroups.includes(I9DocumentGroupsEnum.I9_LIST_A)
              );
              return !!listADocumentPresent;
          }
          if (
              receiptData.length === 1 &&
              receiptData[0]?.documentGroups.includes(documentGroup)
          ) {
              return true;
          }
      }
      return false;
  };

  return (
    <Box>
      {store.isLoading ? (
        <Box>
          <Skeleton />
          <Skeleton />
        </Box>
      ) : (
        // @ts-ignore
        <I9DocumentUploadProvider documentResponse={getDocumentResponse()}
        isListCReceiptDocument={checkDocumentGroup(I9DocumentGroupsEnum.I9_LIST_C)}
        isListAReceiptDocument={checkDocumentGroup(I9DocumentGroupsEnum.I9_LIST_A)}
        >
          <I9DocumentUploadV1
           store={store}
            onConfirm={onConfirm} 
            isReceiptUpload={isReceiptUpload}
            onUseOtherDocuments={onUseOtherDocuments}
            />
        </I9DocumentUploadProvider>
      )}
    </Box>
  );
};

export default observer(I9DocumentUploadV1Wrapper);



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-upload/v2/I9DocumentUploadV1Wrapper.tsx